import axiosInstance from '../axiosConfigCMS';

export default {
  async getSocial() {
    const response = await axiosInstance.get('/footer-social');
    return response.data;
  },
  async getLinks() {
    const response = await axiosInstance.get('/footer-links');
    const data = response.data.filter((val) => !val.Name.includes('AMVD'));
    return data;
  },
};
